import { dataCity } from "../../data/VietNamData/DataCity";
import { dataDistrict } from "../../data/VietNamData/DataDistrict";
import { dataWard } from "../../data/VietNamData/DataWard";

/**
"OfficeType": "TRADING" : là phòng giao dịch => sẽ không có header chọn CN/PGD
"OfficeType": "BRANCH" : Sẽ có header chọn CN/PGD
"OfficeType": "HEAD" :  là admin trụ sở chính" hội sở" =>  sẽ không có header chọn CN/PGD
 */
const OfficeType = {
    TRADING: "TRADING",
    BRANCH: 'BRANCH',
    HEAD: 'HEAD'
}

const _getOfficeID = ({dataLogin, generalOfficeSelected}) => {
    let officeId = dataLogin.OfficeID
    if(generalOfficeSelected && dataLogin.OfficeType === OfficeType.BRANCH){
        officeId = generalOfficeSelected.ID
    }
    return officeId
}

const _getOfficeName = ({dataLogin, generalOfficeSelected}) => {
    let officeName = dataLogin.OfficeName
    if(generalOfficeSelected && dataLogin.OfficeType === OfficeType.BRANCH){
        officeName = generalOfficeSelected.Name
    }
    return officeName
}

const _getOfficeAddress = ({dataLogin, generalOfficeSelected}) => {
    let address = [
        dataLogin.OfficeAddress,
        dataWard[dataLogin.OfficeWard].name,
        dataDistrict[dataLogin.OfficeDistrict].name,
        dataCity[dataLogin.OfficeProvince].name
    ]
    if(generalOfficeSelected && Object.keys(generalOfficeSelected).length > 0 && dataLogin.OfficeType === OfficeType.BRANCH){
        address = [
            generalOfficeSelected.Address,
            dataWard[generalOfficeSelected.Ward].name,
            dataDistrict[generalOfficeSelected.District].name,
            dataCity[generalOfficeSelected.Province].name
        ]
    }
    return address.join(", ")
}

const _getOfficeInfo = ({dataLogin, generalOfficeSelected}) => {
    let officeInfo = dataLogin
    if(generalOfficeSelected && dataLogin.OfficeType === OfficeType.BRANCH){
        officeInfo = generalOfficeSelected
    }
    return officeInfo
}

const _getOfficeList = ({dataLogin, officeManagementList}) => {
    let officeList = []
    if( dataLogin.OfficeType === OfficeType.BRANCH){
        if(officeManagementList.length > 0){
            officeList.push(officeManagementList[0])
            if(officeManagementList.length > 1){
                const dataList = officeManagementList.slice(1).sort((a, b) =>
                    Number(a.BranchCode) - Number(b.BranchCode)
                )
                officeList.push(...dataList)
            }
        }
        
        //---
       
    }
    
    return officeList
}

const _checkBranchOfficeType = ({dataLogin}) => {
    if( dataLogin.OfficeType === OfficeType.BRANCH){
       return true
    }
    return false
}

const officeUtils = {
    getOfficeID: _getOfficeID,
    getOfficeName: _getOfficeName,
    getOfficeInfo: _getOfficeInfo,
    getOfficeList: _getOfficeList,
    getOfficeAddress: _getOfficeAddress,
    isBranchOfficeType: _checkBranchOfficeType,
}

export  {
    officeUtils,
    OfficeType
}